import React from 'react';

/**
 * Full-screen blocking overlay shown when the app version is below the
 * minimum required (Remote Config gate) or when maintenance mode is active
 * (RTDB real-time kill switch).
 *
 * Renders above everything (z-[9999]) and cannot be dismissed.
 * For web apps the action is "Refresh Page" since the new version is
 * served immediately on page load.
 */
export default function VersionGateOverlay({ message, isMaintenanceMode }) {
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/95 backdrop-blur-sm">
      <div className="max-w-md mx-auto p-8 bg-gray-900 rounded-2xl border border-gray-700 text-center shadow-2xl">
        <div className="text-5xl mb-5">
          {isMaintenanceMode ? '\u{1F527}' : '\u{1F504}'}
        </div>

        <h2 className="text-xl font-bold text-white mb-2">
          {isMaintenanceMode ? 'Maintenance in Progress' : 'Update Required'}
        </h2>

        <p className="text-sm text-gray-400 mb-6 leading-relaxed">
          {message || (isMaintenanceMode
            ? 'The system is temporarily under maintenance. Please check back shortly.'
            : 'A new version of CricketXtreme is available. Please refresh to continue.'
          )}
        </p>

        {!isMaintenanceMode && (
          <button
            onClick={() => window.location.reload()}
            className="px-8 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-xl font-semibold text-sm transition-colors"
          >
            Refresh Page
          </button>
        )}
      </div>
    </div>
  );
}
